import { render, staticRenderFns } from "./FoodRetention.vue?vue&type=template&id=70d7b095&scoped=true"
import script from "./FoodRetention.vue?vue&type=script&lang=js"
export * from "./FoodRetention.vue?vue&type=script&lang=js"
import style0 from "./FoodRetention.vue?vue&type=style&index=0&id=70d7b095&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d7b095",
  null
  
)

export default component.exports